<template>
  <LoginHolder>
    <AlertMessageSuccess :alerMessage="alerMessageSuccess"></AlertMessageSuccess>
    <AlertMessage :alerMessage="alerMessage"></AlertMessage>
    <h2 class="mb-1 pb-3">{{title}}</h2>
    <p v-if="!validToken">{{subtitle}}</p>
    <ValidationObserver ref="observer">
      <form
        ma-8
        v-on:submit.prevent>
        <v-container class="container-bg-color pa-0" fluid fill-height>
          <v-row align="center" style="height:100%;" v-if="validToken">
            <v-col cols="12">
              <ValidationProvider v-slot="{ errors }" name="New Password" rules="required|min:6">

                <v-text-field
                  v-model="user.encrypted_password"
                  :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  :type="passShow ? 'text' : 'password'"
                  name="input-10-2"
                  :disabled="loading"
                  label="New Password"
                  autocomplete="false"
                  ref="password"
                  class="input-group--focused mt-3"
                  @click:append="passShow = !passShow"
                ></v-text-field>


              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider v-slot="{ errors }" name="Confirm New Password" rules="required|confirmed:New Password|min:6">

                <v-text-field
                  v-model="user.confirm_password"
                  :append-icon="confirmPassShow ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="errors"
                  :type="confirmPassShow ? 'text' : 'password'"
                  name="input-10-2"
                  :disabled="loading"
                  autocomplete="false"
                  label="Confirm New Password"
                  class="input-group--focused mt-3"
                  @click:append="confirmPassShow = !confirmPassShow"
                ></v-text-field>

              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
        <v-btn class="d-none" @click="reset"></v-btn>
      </form>
    </ValidationObserver>

    <v-btn
      depressed
      block
      rounded
      large
      v-if="validToken"
      color="primary"
      class="mb-8 mt-6"
      @click="updatePassword()"
      :disabled="loading"
      >
      {{ loading ? 'Please wait...' : 'Change Password' }}

    </v-btn>

    <v-btn
      depressed
      block
      rounded
      large
      v-if="!validToken"
      color="primary"
      class="mb-8 mt-6"
      :to="{ name: 'forgot-password' }"
    >
      Reset Password
    </v-btn>

    <v-btn
      depressed
      block
      rounded
      large
      :to="{ name: 'login' }"
    >
      {{ validToken ? 'Cancel' : 'Login' }}
    </v-btn>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import { mapGetters } from "vuex";
  import { required, email, confirmed, min } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import AlertMessageSuccess from '@/components/AlertMessageSuccess.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('min', {
    ...min,
    message: '{_field_} must be at least {length} characters',
  })

  extend("confirmed", {
    ...confirmed,
    message: "The password does not match",
  });

  export default {
    name: 'ConfirmResetPasswordToken',
    data: () => ({
      passShow: false,
      confirmPassShow: false,
      title: 'Confirming Password Token ...',
      subtitle: 'Please wait...',
      user: {
        encrypted_password: '',
        confirm_password: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      alerMessageSuccess:{
        show: false,
        omitMessage: '',
        message: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      loading: false,
      validToken: false,
      token: ''
    }),
    computed: {
    },
    methods: {
      async updatePassword(){
        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this

        this.alerMessageSuccess.message = ''
        this.alerMessageSuccess.show = false

        this.user.token = this.token

        this.$http.secured.post('/users/update-password', this.user)
          .then(response => {
            this.showMessage("Your password has been changed.", 'success')
            this.alerMessageSuccess.message = response.data.message
            this.alerMessageSuccess.show = true
            this.clear()
            setTimeout(function(){
              self.$router.push({ name: 'login' })
            }, 10000);
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      confirmToken(){
        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this
        this.$http.plain.get('users/validate-password-reset-confirmation-token?token='+this.token)
          .then(response => {
            this.validToken = true
            this.title = 'Update your password'
            this.subtitle = ''
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
              this.title = ''
              this.subtitle = ''
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()
      },
    },
    mounted() {
      if(this.$route.query.token){
        this.token = this.$route.query.token
        this.confirmToken()
      }else{
        this.alerMessage.messages = ['Invalid token']
        this.alerMessage.show = true
        this.title = ''
        this.subtitle = ''
      }
    },
    components: {
      SnackBar,
      ValidationProvider,
      ValidationObserver,
      LoginHolder,
      AlertMessage,
      AlertMessageSuccess
    },
  }
</script>
